import { capitalize } from 'lodash'
import { observable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'
import * as R from 'ramda'

class InheritedQuestionSlide {
    id = uuidv4()

    kind = 'InheritedQuestionSlide'

    @observable childPageQuestionId

    @observable comparisonSurveyIds

    removeBaseLimit

    display

    comment

    parentDataRanking

    ranking

    constructor({
        comparisonSurveyIds = [],
        childPageQuestionId,
    }) {
        this.comparisonSurveyIds = comparisonSurveyIds
        this.childPageQuestionId = childPageQuestionId
    }

    arrayOrUndefined = (arr) => {
        const checked = Array.isArray(arr)
            ? arr.filter(({ checked }) => checked)
            : []

        return checked.length > 0
            ? checked.map(({ value }) => capitalize(value))
            : undefined
    }

    toJSON() {
        return {
            kind: this.kind,
            childPageQuestionId: this.childPageQuestionId,
            // comparisonSurveyIds: this.arrayOrUndefined(this.comparisonSurveyIds.slice()),
            comparisonSurveyIds: undefined, // temporarily disabling comparison years
            removeBaseLimit: !R.isNil(this.removeBaseLimit)
                ? parseInt(this.removeBaseLimit, 10)
                : undefined,
            display: this.display,
            comment: this.comment,
            parentDataRanking: this.parentDataRanking,
            ranking: this.ranking,
        }
    }
}

export default InheritedQuestionSlide
